import React from "react";
import Modal from "../../Elements/Modal/Modal";
import { useSelector } from "react-redux";
import AutoPlaySelector from "../UI/AutoPlaySelector/AutoPlaySelector";
import { useTranslation } from "react-i18next";
import ButtonAutoPlay from "../UI/ButtonAutoPlay/ButtonAutoPlay";

const AutoPlayModal = () => {
  const { modalOpen } = useSelector((state) => state.modal);
  const { t } = useTranslation();

  return (
    <Modal
      name="autoPlay"
      modifier="modalAutoPlay"
      active={modalOpen}
      title={t("auto_play_settings")}
    >
      <AutoPlaySelector />
      <ButtonAutoPlay />
    </Modal>
  );
};

export default AutoPlayModal;
